import script from "./ElementOpacity.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementOpacity.vue?vue&type=script&lang=ts&setup=true"

import "./ElementOpacity.vue?vue&type=style&index=0&id=57381879&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57381879"]])

export default __exports__